import React from "react";
import styled from "styled-components";
// import { useInView } from "react-intersection-observer";

const Holder = styled.div`
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border-radius: 16px;
  position: relative;
  overflow: hidden;

  div {
    opacity: 0;
    transition: all 0.4s;
  }

  &:hover {
    div {
      opacity: 1;
      transition: all 0.4s;
    }
  }
`;

const Video = styled.video`
  position: absolute;
  left: 0px;
  top: 0px;
  height: 100%;
  width: 100%;
  mix-blend-mode: difference;
  object-fit: cover;
  z-index: 1;
`;

const Overlay = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;
  height: 100%;
  width: 100%;
  background: rgba(206, 206, 206, 0.59);
  mix-blend-mode: difference;
  z-index: 1;
`;

const Tag = styled.div`
  position: absolute;
  left: 24px;
  top: 24px;
  width: fit-content;
  padding: 4px 16px;
  color: #000;
  border-radius: 20px;
  border: 1px solid #000;
  font-family: "Whyte";
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 100%; /* 16px */
  letter-spacing: -0.32px;
  z-index: 2;
  user-select: none;
`;

const Text = styled.div`
  color: #000;
  font-family: "Whyte";
  font-size: 20px;
  font-style: normal;
  font-weight: 350;
  line-height: 130%; /* 26px */
  letter-spacing: -0.4px;
  position: absolute;
  left: 24px;
  right: 24px;
  top: 64px;
  z-index: 3;
  user-select: none;
  white-space: break-spaces;
`;

const Project = ({ image, video, text, width, height, tag }) => {
  const isMobile = window.innerWidth <= 1024 ? true : false;
  const _height = isMobile ? 540 : height;
  const _width = isMobile ? (540 * width) / height : width;

  // const { ref, inView } = useInView({
  //   threshold: 0.01,
  //   triggerOnce: true,
  // });

  return (
    <Holder
      // ref={ref}
      style={{
        backgroundImage: image && !video ? `url("${image}")` : null,
        width: _width,
        height: _height,
      }}>
      <Overlay></Overlay>
      <Tag>{tag}</Tag>
      <Text>{text}</Text>
      {/* {video && inView ? ( */}
      <Video
        autoPlay
        muted
        playsInline
        loop
        preload="auto"
        disablePictureInPicture>
        <source src={video} type="video/mp4" />
      </Video>
      {/* ) : (
        <></>
      )} */}
    </Holder>
  );
};

export default Project;
